/**
 * FE override map for Current Step thumbnail (D-04).
 * Keyed by `id` returned from GET /api/current-step (Phase 35-03 mock payload).
 * When CSC-FUT-01 ships real cycle/protocol data + CDN thumbnails, delete this file.
 *
 * Add ids returned by Phase 35-03 endpoint as Figma exports land in
 * public/images/track/. The Phase 35-03 payload id is captured in
 * 35-CONTEXT D-15/D-16; verify by hitting /api/current-step in dev once and
 * recording the id here.
 */
export const CURRENT_STEP_ASSETS: Record<string, string> = {
	"stim-day-5": "/images/track-thumbnail.png",
};

export function getCurrentStepAsset(id: string): string | undefined {
	return CURRENT_STEP_ASSETS[id];
}
